// TODO: replace string literals with variables - (phyoh)
import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

type RpEventParams = {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  entryPoint?: string;
};

type RpEventParamsWithSecondsOnPage = RpEventParams & {
  secondsOnPage: number;
};

// https://dataportal.zillowgroup.net/event-registry/3140
const ViewIllustrativeProductIntro = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3140',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'rental_protection_product_intro',
    },
    semantic: {
      semantic_event_nm: 'start_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3141
const ViewComparisonChart = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3141',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'impression',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'comparison_chart',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3142
const ViewHighlights = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3142',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'impression',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'highlights',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3143
const TimeOnPage = ({ currentProperty = {}, user, entryPoint = '', secondsOnPage }: RpEventParamsWithSecondsOnPage) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3143',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'impression',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: `time_spent_on_page_${secondsOnPage}_seconds`,
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3174
const ClickFindOutMoreTop = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3174',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'top_of_page',
      trigger_source_nm: `find_out_more`,
    },
    semantic: {
      semantic_event_nm: 'continue_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3175
const ClickFindOutMoreBottom = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3175',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'bottom_of_page',
      trigger_source_nm: `find_out_more`,
    },
    semantic: {
      semantic_event_nm: 'continue_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3176
const ClickFindOutMoreFooter = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3176',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'footer',
      trigger_source_nm: `find_out_more`,
    },
    semantic: {
      semantic_event_nm: 'continue_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3144
const ClickNextHowDoesItWork = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3144',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'how_does_it_work_modal',
      trigger_source_nm: `next`,
    },
    semantic: {
      semantic_event_nm: 'continue_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3177
const ClickYesContinueInterestedModal = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3177',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'optin_modal',
      trigger_source_nm: `yes_continue`,
    },
    semantic: {
      semantic_event_nm: 'complete_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3145
const ClickNextReviewSecurityDeposit = ({
  currentProperty = {},
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3145',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'review_security_deposit_modal',
      trigger_source_nm: `next`,
    },
    semantic: {
      semantic_event_nm: 'continue_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3146
const ClickLostRentTooltip = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3146',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: `lost_rent_tooltip`,
    },
    semantic: {
      semantic_event_nm: 'continue_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3147
const ClickDamageToUnitTooltip = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3147',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: `damage_to_unit_tooltip`,
    },
    semantic: {
      semantic_event_nm: 'continue_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3148
const ClickSeeCoverageExamples = ({ currentProperty = {}, user, entryPoint = '' }: RpEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: '3148',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_product_intro',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: `see_coverage_examples`,
    },
    semantic: {
      semantic_event_nm: 'continue_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/4648
const ViewCoverageSelectionPage = ({
  currentProperty = {},
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: '4648',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: `rental_protection_manage_policy`,
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/4649
const ClickWhatsCovered = ({
  currentProperty = {},
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: '4649',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'overview_section',
      trigger_source_nm: `whats_covered`,
    },
    semantic: {
      semantic_event_nm: 'learn_more_rental_protection_policy',
      topic_tag_txt: [],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/4650
const ClickLearnMore = ({
  currentProperty = {},
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: '4650',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'overview_section',
      trigger_source_nm: `learn_more`,
    },
    semantic: {
      semantic_event_nm: 'learn_more_rental_protection_policy',
      topic_tag_txt: [],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/4651
const ClickHowItWorks = ({
  currentProperty = {},
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: '4651',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'how_to_purchase_section',
      trigger_source_nm: `how_it_works`,
    },
    semantic: {
      semantic_event_nm: 'learn_more_rental_protection_policy',
      topic_tag_txt: [],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const OptInCSEvents = {
  ILLUSTRATIVE_PRODUCT_INTRO: {
    ViewIllustrativeProductIntro,
    ViewComparisonChart,
    ViewHighlights,
    TimeOnPage,
    ClickFindOutMoreTop,
    ClickFindOutMoreBottom,
    ClickFindOutMoreFooter,
    ClickLostRentTooltip,
    ClickDamageToUnitTooltip,
    ClickSeeCoverageExamples,
  },
  TWO_STEP_OPT_IN: {
    ClickNextHowDoesItWork,
    ClickYesContinueInterestedModal,
    ClickNextReviewSecurityDeposit,
  },
  COVERAGE_SELECTION: {
    ViewCoverageSelectionPage,
    ClickWhatsCovered,
    ClickLearnMore,
    ClickHowItWorks,
  },
};

export default OptInCSEvents;
